import React from 'react';
import { FaCheck } from 'react-icons/fa';

import { MEMBERSHIP_BENEFITS } from './membershipBenefits.js';

/**
 * @param {{ variant?: 'learn-more' | 'big-top' }} props
 */
export default function MembershipBenefitsList({ variant = 'learn-more' }) {
  const isBigTop = variant === 'big-top';
  const listClass = isBigTop ? 'about__benefits list-unstyled' : 'paywall-learn-more__benefits list-unstyled';
  const itemClass = isBigTop ? 'about__benefit' : 'paywall-learn-more__benefit';
  const checkClass = isBigTop ? 'about__check' : 'paywall-learn-more__check';

  return (
    <ul className={listClass}>
      {MEMBERSHIP_BENEFITS.map((benefit) => (
        <li key={benefit} className={itemClass}>
          <FaCheck className={checkClass} aria-hidden="true" />
          <span>{benefit}</span>
        </li>
      ))}
    </ul>
  );
}
